export default __webpack_public_path__ + "static/media/kitchen4-afterE-1920w.a72e2475.avif";